import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import AuthService from '../utils/AuthService';
import { withRouter } from 'react-router';

import SiteLogo from '../assets/images/global/seakeeper-logo.png';

class Header extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();
		let user = this.Auth.getProfile(),
			siteLink = <a href="/" className="pp-site-link"><img src={ SiteLogo } className="pp-site-logo" alt="" /></a>;

		this.handleLogout = this.handleLogout.bind(this);
		this.toggleMobileMenu = this.toggleMobileMenu.bind(this);

		this.state = {
			mobileMenu: false
		}

		if (user !== null) {
			switch (user.pp_role_id * 1) {
				case 1:
					this.loggedInMenu = <ul className="pp-site-menu">
						<li className="pp-menu-item-wrapper">
							<NavLink to="/dashboard" className="pp-menu-item">Dashboard</NavLink>
						</li>
						<li className="pp-menu-item-wrapper">
							<NavLink to="/manage-boats" className="pp-menu-item">Manage Vessels</NavLink>
						</li>
						<li className="pp-menu-item-wrapper">
							<NavLink to="/manage-users" className="pp-menu-item">Manage Users</NavLink>
						</li>
						<li className="pp-menu-item-wrapper">
							<NavLink to="/sizing-form/status/rejected" className="pp-menu-item">Rejected Forms</NavLink>
						</li>
					</ul>
					break;
				case 90:
				case 100:
					this.loggedInMenu = <ul className="pp-site-menu">
						<li className="pp-menu-item-wrapper">
							<NavLink to="/dashboard" className="pp-menu-item">Dashboard</NavLink>
						</li>
						<li className="pp-menu-item-wrapper">
							<NavLink to="/view-boats" className="pp-menu-item">Vessel Database</NavLink>
						</li>
					</ul>
					break;
				case 200:
					this.loggedInMenu = <ul className="pp-site-menu">
						<li className="pp-menu-item-wrapper">
							<NavLink to="/dashboard" className="pp-menu-item">Dashboard</NavLink>
						</li>
					</ul>
					break;
			}
			this.navMenu = <nav className="pp-site-nav">
				{siteLink}
				<div className="pp-menu-wrap">
					{this.loggedInMenu}
					<ul className="pp-profile-menu">
						<li className="pp-menu-item-wrapper">
							<span className="pp-menu-item">Hello{user.first_name && ', ' + user.first_name}</span>
							<ul className="pp-sub-menu">
								<li className="pp-menu-item-wrapper">
									<NavLink to="/settings" className="pp-menu-item">Settings</NavLink>
								</li>
								<li className="pp-menu-item-wrapper">
									<span className="pp-menu-item" onClick={this.handleLogout}>Logout</span>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</nav>
		} else {
			this.navMenu = <nav className="pp-site-nav">
				{siteLink}
				<div className="pp-menu-wrap">
					<ul className="pp-site-menu">
						<li className="pp-menu-item-wrapper">
							<NavLink to="/login" className="pp-menu-item">Login</NavLink>
						</li>
					</ul>
				</div>
			</nav>
		}
	}

	toggleMobileMenu() {
		this.setState({
			mobileMenu: !this.state.mobileMenu
		});
	}

	handleLogout() {
		this.Auth.logout();
		this.props.history.replace('/login');
	}

	render() {
		let mobileMenuClass = '';
		if (this.state.mobileMenu === true) {
			mobileMenuClass = ' mobile-menu-open ';
		}
		return (
			<div className={'pp-site-header' + mobileMenuClass}>
				{this.navMenu}
				<button className="mobile-menu-toggle" onClick={this.toggleMobileMenu}>
					<span className="screen-reader">Menu</span>
					<div className="line"></div>
					<div className="line"></div>
					<div className="line"></div>
				</button>
			</div>
		);
	}
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js